var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"panel panel-default\">\n"
    + ((stack1 = container.invokePartial(require("./sidebar-heading.hbs"),depth0,{"name":"sidebar-heading","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    <div id=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "-collapse-sidebar\" class=\"panel-collapse collapse\">\n        <div class=\"panel-body layer-actions\">\n            <div class=\"row\">\n                <div class=\"col-xs-12\">\n                    <input id=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "-"
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"dropdown") : depth0)) != null ? lookupProperty(stack1,"name") : stack1), depth0))
    + "-dropdown\" class=\"select select-lg\" name=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"dropdown") : depth0)) != null ? lookupProperty(stack1,"name") : stack1), depth0))
    + "\"/>\n                </div>\n"
    + ((stack1 = container.invokePartial(require("./sidebar-links.hbs"),depth0,{"name":"sidebar-links","data":data,"indent":"                ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + ((stack1 = container.invokePartial(require("./sidebar-checkbox.hbs"),depth0,{"name":"sidebar-checkbox","data":data,"indent":"                ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "            </div>\n        </div>\n    </div>\n</div>\n";
},"usePartial":true,"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/sidebar-raster-maps.hbs
// module id = T0f6
// module chunks = 1